import {
  LOAD_CURRENCIES,
  LOAD_CURR_MARKETS,
  SET_CURRENCIES,
  SET_EXCH_CURRS,
  SET_BTC_EXCH_RATE,
  SET_CURRENCY_DETAIL,
  SET_CURR_OHLC,
  SET_CURR_MARKETS,
  SET_TABLE_EXCH_RATE,
  SET_DEFAULT_MARKET,
} from '../actions/currenciesActions'
import CurrencyModel from '../../models/CurrencyModel'
import MarketModel from '../../models/MarketModel'
import { OHLCData } from '../types'

export interface CurrenciesState {
  currencies: CurrencyModel[]
  exchCurrs: CurrencyModel[]
  loading: boolean
  btcExchRate: number
  tableExchRate: number
  currency: CurrencyModel | false
  ohlc: OHLCData[]
  ohlcQuoteCurr: string
  currMarkets: MarketModel[]
  loadingCurrMarkets: boolean
  defaultMarket: MarketModel | Record<string, never>
}

interface CurrenciesAction {
  type: string
  currencies?: CurrencyModel[]
  exchCurrs?: CurrencyModel[]
  btcExchRate?: number
  tableExchRate?: number
  currency?: CurrencyModel
  ohlc?: OHLCData[]
  ohlcQuoteCurr?: string
  currMarkets?: MarketModel[]
  defaultMarket?: MarketModel
}

const initialState: CurrenciesState = {
  currencies: [],
  exchCurrs: [],
  loading: false,
  btcExchRate: 1,
  tableExchRate: 1,
  currency: false,
  ohlc: [],
  ohlcQuoteCurr: '',
  currMarkets: [],
  loadingCurrMarkets: false,
  defaultMarket: {},
}

const currenciesReducer = (state: CurrenciesState = initialState, action: CurrenciesAction): CurrenciesState => {
  switch (action.type) {
    case LOAD_CURRENCIES:
      return {
        ...state,
        loading: true,
      }
    case SET_CURRENCIES:
      return {
        ...state,
        currencies: action.currencies || [],
        loading: false,
      }
    case SET_EXCH_CURRS:
      return {
        ...state,
        exchCurrs: action.exchCurrs || [],
        loading: false,
      }
    case SET_BTC_EXCH_RATE:
      return {
        ...state,
        btcExchRate: action.btcExchRate || 1,
      }
    case SET_TABLE_EXCH_RATE:
      return {
        ...state,
        tableExchRate: action.tableExchRate || 1,
      }
    case SET_CURRENCY_DETAIL:
      return {
        ...state,
        currency: action.currency || false,
      }
    case LOAD_CURR_MARKETS:
      return {
        ...state,
        loadingCurrMarkets: true,
      }
    case SET_CURR_MARKETS:
      return {
        ...state,
        currMarkets: action.currMarkets || [],
        loadingCurrMarkets: false,
      }
    case SET_CURR_OHLC:
      return {
        ...state,
        ohlc: action.ohlc || [],
        ohlcQuoteCurr: action.ohlcQuoteCurr || '',
      }
    case SET_DEFAULT_MARKET:
      return {
        ...state,
        defaultMarket: action.defaultMarket || {},
      }
    default:
      return state
  }
}

export default currenciesReducer 